import * as config from "config-api";
import { fetch } from "../../index";
import { forYouVerticalVideosQuery } from "../../queries/personalizedItems";

const GRAPHQL_BASE_URL = config.getString("Client.contentApi.baseGraphqlURL");

export const fetchForYouVerticalVideos = (userId) => {
    return fetch(
        GRAPHQL_BASE_URL,
        {
            query: forYouVerticalVideosQuery(userId),
        },
        false
    );
};
